import { render, staticRenderFns } from "./NewBlockTable.vue?vue&type=template&id=cbadc64c&"
import script from "./NewBlockTable.vue?vue&type=script&lang=js&"
export * from "./NewBlockTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports